import { Component, OnInit, ViewChild } from '@angular/core';
import { TdSearchBoxComponent, ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdLoadingService, ITdDataTableSortChangeEvent, IPageChangeEvent, TdDialogService } from '@covalent/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { SettingsService } from 'app/shared/services/settings.service';
import { ExportService } from 'app/shared/services/export.service';
import { AuthenticationService } from 'app/shared/services/authentication.service';
import { GradeService } from 'app/shared/services/grade.service';
import { Utils } from 'app/shared/utils';
import { Grade } from '../grade';

@Component({
  selector: 'app-grades',
  templateUrl: './grades.component.html',
  styleUrls: ['./grades.component.scss']
})
export class GradesComponent implements OnInit {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: any[];

  columns: ITdDataTableColumn[] = [
    { name: 'external_id', label: 'External ID' },
    { name: 'name', label: 'Name' },
    { name: 'description', label: 'Description' },
  ];

  filteredData: any[];
  filteredTotal: number;
  //searchTerm: string;

  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: MdDialog,
    private _loadingService: TdLoadingService,
    private _gradeService: GradeService,
    private _settingsService: SettingsService,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this._loadingService.register('loading');

    this.presetSearchBox();

    this._gradeService.getGrade().subscribe(
      response => {
        console.log(response);
        this.data = response;
      },
      error => {
        console.log(error)
      },
      () => {
        this._loadingService.resolve('loading');
        this.filter();
      }
    );
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('grade')) {
      this._searchBox.value = this._settingsService.getSearchTerm('grade');
      this._searchBox.searchClicked();
    }
  }

  openAddNewGradeDialog() {
    this._dialogService.open(NewGradeDialog).afterClosed().subscribe(
      result => {
        if (result != null) {
          this.data.push(result);
          this.filter();
        }
      }
    );
  }

  openEditGradeDialog(gradeRow: Grade) {
    let _dialog: MdDialogRef<NewGradeDialog> = this._dialogService.open(NewGradeDialog);

    _dialog.componentInstance.grade = gradeRow;

    _dialog.afterClosed().subscribe(
      result => {
        if (result != null) {
          gradeRow = result;
          this.filter();
        }
      }
    );
  }

  deleteSelected() {
    this._loadingService.register('loading');

    this.selectedRows.forEach(
      (grade) => {
        this._gradeService.removeGrade(grade.id).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.data = this.data.filter(function (c) { return c['id'] != response['id'] });
            } else {
              console.log('Could not delete ' + grade.name);
            }
          },
          error => {
            console.log(error);
          },
          () => {
            this._loadingService.resolve('loading');

            this.filter();
          }
        );
      }
    );

    this.selectedRows = [];
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;

    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;

    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('grade', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;

    //this.pageSize = pagingEvent.pageSize;
    this._settingsService.setPageSize(pagingEvent.pageSize);

    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('grade'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

}


@Component({
  selector: 'new-grade-dialog',
  template: `
    <div flex layout="column" layout-margin layout-wrap>
      <h4>{{ isEditMode?'Enter new grade':'Edit Grade' }}</h4>
      <md-divider></md-divider>
      <md-input-container>
        <input mdInput type="text" placeholder="External ID" [(ngModel)]="grade.external_id">
      </md-input-container>
      <md-input-container>
        <input mdInput type="text" placeholder="Grade" [(ngModel)]="grade.name">
      </md-input-container>
      <md-input-container>
        <input mdInput type="text" placeholder="Description" [(ngModel)]="grade.description">
      </md-input-container>
      <div flex layout="row" layout-wrap>
        <button md-raised-button color="primary" *ngIf="!isEditMode" class="bg-blue color-white" (click)="addGrade()">Add</button>
        <button md-raised-button color="primary" *ngIf="isEditMode" class="bg-blue color-white" (click)="editGrade()">Save</button>
        <button md-raised-button color="primary" class="bg-blue color-white" (click)="dialogRef.close()">Close</button>
      </div>
    </div>
  `,
})
export class NewGradeDialog implements OnInit {
  countries: any[] = [];

  grade: Grade = new Grade();

  isEditMode: boolean = false;

  constructor(public dialogRef: MdDialogRef<NewGradeDialog>,
    private tdDialog: TdDialogService,
    private _gradeService: GradeService) { }

  ngOnInit() {
    if (this.grade.id) {
      this.isEditMode = true;
    }
  }

  addGrade() {
    this._gradeService.addGrade(this.grade).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.tdDialog.openAlert(
            {
              title: 'Success!',
              message: 'Grade added successfully'
            }
          );
          this.dialogRef.close(this.grade);
        } else {
          this.tdDialog.openAlert(
            {
              title: 'Failed!',
              message: 'Could not add grade'
            }
          );
          this.dialogRef.close();
        }
      },
      error => {
        this.tdDialog.openAlert(
          {
            title: 'Error!',
            message: 'An error occurred. Try again later.'
          }
        );
        this.dialogRef.close();
      },
      () => {

      }
    );

  }

  editGrade() {
    this._gradeService.updateGrade(this.grade.id + '', this.grade).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.tdDialog.openAlert(
            {
              title: 'Success!',
              message: 'Grade edited successfully'
            }
          );
          this.dialogRef.close(this.grade);
        } else {
          this.tdDialog.openAlert(
            {
              title: 'Failed!',
              message: 'Could not add grade'
            }
          );
          this.dialogRef.close();
        }
      },
      error => {
        this.tdDialog.openAlert(
          {
            title: 'Error!',
            message: 'An error occurred. Try again later.'
          }
        );
        this.dialogRef.close();
      },
      () => {

      }
    );
  }
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/grades/grades.component.ts